import { ActionIcon } from '@mantine/core';

export const ActionIconConfig = ActionIcon.extend({
  defaultProps: {
    color: 'dark',
    variant: 'subtle',
  },
});
